import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // ← named import

export const AuthContext = createContext({
    token: null,
    roles: [],
    login: (token) => {},
    logout: () => {},
    isLoggedIn: false,
});


export function AuthProvider({ children }) {
    const [token, setToken] = useState(null);
    const [roles, setRoles] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    // On mount, attempt to load a saved token from localStorage
    useEffect(() => {
        const savedToken = localStorage.getItem("token");
        if (savedToken) {
            try {
                const { roles: savedRoles, exp } = jwtDecode(savedToken);
                const now = Date.now() / 1000;
                if (exp > now) {
                    setToken(savedToken);
                    setRoles(savedRoles || []);
                    setIsLoggedIn(true);
                } else {
                    localStorage.removeItem("token");
                }
            } catch {
                localStorage.removeItem("token");
            }
        }
    }, []);

    const login = (tokenStr) => {
        try {
            const { roles: decodedRoles, exp } = jwtDecode(tokenStr);
            const now = Date.now() / 1000;
            if (exp > now) {
                localStorage.setItem("token", tokenStr);
                setToken(tokenStr);
                setRoles(decodedRoles || []);
                setIsLoggedIn(true);
            } else {
                console.error("Cannot store expired token.");
            }
        } catch {
            console.error("Invalid JWT");
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        setToken(null);
        setRoles([]);
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider
            value={{
                token,
                roles,
                login,
                logout,
                isLoggedIn,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;
